import Slider from 'react-slick';
import ImgCaution1 from '../../assets/image/img_caution_1.png';
import ImgCaution2 from '../../assets/image/img_caution_2.jpg';
import ImgCaution3 from '../../assets/image/img_caution_3.jpg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useTranslation } from '../../hook/useTranslation';

const RecordingGuideCarousel = () => {
  const { t } = useTranslation();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    customPaging: () => (
      <div
        style={{
          width: '8px',
          height: '8px',
          background: '#D9D9D9',
          borderRadius: '50%',
          margin: '0 4px',
        }}
        className="custom-dot"
      />
    ),
  };

  return (
    <div className="w-full max-w-[300px] h-[348px] mx-auto rounded-[24px] overflow-hidden relative">
      <style>
        {`
          .slick-dots {
            bottom: 20px;
          }
          .slick-dots li {
            margin: 0;
          }
          .slick-dots li.slick-active .custom-dot {
            background: #5EBEBB !important;
            width: 20px !important;
            border-radius: 10px !important;
          }
        `}
      </style>
      <Slider {...settings}>
        <div className="relative w-full h-[348px]">
          <img src={ImgCaution1} alt="Slide 1" className="w-full h-full object-cover" />
          <div className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.5)] flex flex-col items-center justify-center font-[700] text-[20px] text-white">
            <div className="w-full text-center">{t('register.recording_guide.slide1_1')}</div>
            <div className="w-full text-center">{t('register.recording_guide.slide1_2')}</div>
          </div>
        </div>
        <div className="relative w-full h-[348px]">
          <img src={ImgCaution2} alt="Slide 2" className="w-full h-full object-cover" />
          <div className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.5)] flex flex-col items-center justify-center font-[700] text-[20px] text-white">
            <div className="w-full text-center">{t('register.recording_guide.slide2_1')}</div>
            <div className="w-full text-center">{t('register.recording_guide.slide2_2')}</div>
          </div>
        </div>
        <div className="relative w-full h-[348px]">
          <img src={ImgCaution3} alt="Slide 3" className="w-full h-full object-cover" />
          <div className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.5)] flex flex-col items-center justify-center font-[700] text-[20px] text-white">
            <div className="w-full text-center">{t('register.recording_guide.slide3_1')}</div>
            <div className="w-full text-center">{t('register.recording_guide.slide3_2')}</div>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default RecordingGuideCarousel;
